export class InfoCuenta {
    _id_negociacion: Number;
    numero_cliente: String;
    direccion: String;
    /* id_comuna: String;
    id_region: String;  */
    estado_conexion: String ;
    deuda_total: number;
    f_vencimiento: String;
    saldo_anterior: number;
    f_ultimo_pago: String;
    token: String;
    listaGrafico: any;
 }
